module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/27aa9d4c17269da7370e5577a80ed063.png";